export const featuredTestimonials = {
    init: () => {
        document.querySelectorAll('[data-bs-toggle="tab"]').forEach(button => {
            button.addEventListener('shown.bs.tab', (event) => {
                const targetId = event.target.getAttribute('data-bs-target');
                featuredTestimonials.applyToPane(targetId);
            });
        });

        const activePane = document.querySelector('.tab-pane.show.active');
        if (activePane) {
            featuredTestimonials.applyToPane(`#${activePane.id}`);
        }
    },

    applyToPane: (paneSelector) => {
        // TODO CLEANUP > SCSS
        const pane = document.querySelector(paneSelector);
        if (!pane) return;

        const testimonials = pane.querySelectorAll('.js-testimonial-container');

        testimonials.forEach((testimonial, i) => {
            const colDiv = testimonial.closest('.js-testimonial-col');
            const header = testimonial.querySelector('.js-testimonial-header');
            const titleContainer = testimonial.querySelector('.js-testimonial-title-container');
            const quote = testimonial.querySelector('.js-testimonial-quote-container');
            const featuredQuote = testimonial.querySelector('.js-testimonial-quote-container-featured');

            if (i < 3) {
                // === FEATURED ===
                testimonial.classList.add('featured-testimonial');

                if (colDiv) {
                    colDiv.classList.remove('col-lg-3', 'col-12');
                    colDiv.classList.add('col-lg-4');
                    colDiv.classList.add('px-5');
                }

                if (header) header.classList.add('mb-3');

                if (titleContainer) {
                    titleContainer.classList.remove('col-md-12');
                    titleContainer.classList.add('col-md-8');
                }

                if (quote && quote.classList.contains('testimonial-quote-container')) {
                    quote.classList.remove('testimonial-quote-container');
                    quote.classList.add('testimonial-quote-container-mobile');
                }
            } else {
                // === NON-FEATURED ===
                testimonial.classList.remove('featured-testimonial');
                
                if (colDiv) {
                    colDiv.classList.remove('col-lg-4');
                    colDiv.classList.remove('px-5');
                    colDiv.classList.add('col-lg-3', 'col-12');
                }

                if (header) header.classList.remove('mb-3');

                if (titleContainer) {
                    titleContainer.classList.remove('col-md-8');
                    titleContainer.classList.add('col-md-12');
                }

                if (quote && quote.classList.contains('testimonial-quote-container-mobile')) {
                    quote.classList.remove('testimonial-quote-container-mobile');
                    quote.classList.add('testimonial-quote-container');
                }
            }

            if (featuredQuote) featuredQuote.classList.toggle('util--hidden', i >= 3);
        });
    }
}
